export const isValidDate = (val) => !!Date.parse(val);
